
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/samples/radius",
      function () {
        return require("private-next-pages/samples/radius.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/samples/radius"])
      });
    }
  